import { useLockBodyScroll as useLockBodyScrollFromReactUse } from "react-use";

export const useLockBodyScroll = (locked?: boolean, elementRef?: React.RefObject<HTMLElement> | undefined) => {
	useLockBodyScrollFromReactUse(locked, elementRef);
};
